/**
 * Curx AI — Design Tokens
 *
 * Phase 12 update: token VALUES are CSS variables. Every component that
 * reads `colors.bg`, `colors.primary`, etc. continues to work unchanged
 * — but inline styles like `style={{ background: colors.bg }}` now
 * resolve through the CSS variables defined in
 * `src/design-system/theme.css`, which means dark mode is automatic
 * for every consumer.
 *
 * The hex literals shown after each `var(...)` line are the LIGHT-mode
 * fallback / reference values. They aren't used at runtime — the
 * variables in theme.css are.
 */

export const colors = {
  bg:            'var(--bg-base)',          /* #F7F8FA light */
  card:          'var(--bg-surface)',       /* #FFFFFF light */
  primary:       'var(--primary)',          /* #2F5BFF light */
  textPrimary:   'var(--text-primary)',     /* #0A0A0A light */
  textSecondary: 'var(--text-secondary)',   /* #4A5468 light */
  border:        'var(--border)',           /* #E5E7EB light */
  accentEnergy:  'var(--accent-energy)',    /* #6FCF97 light */
  accentGrowth:  'var(--accent-growth)',    /* #9B8AFB light */
  accentSystem:  'var(--accent-system)',    /* #56CCF2 light */
};

/**
 * For places that need a literal hex (e.g. the orbital SVG hex fill
 * gradient, charts, or anywhere CSS variables can't compose), keep
 * the original light-mode hex codes here. Avoid using these in
 * inline styles — prefer `colors.*` so the value tracks the theme.
 */
export const colorsLightHex = {
  bg:            '#F7F8FA',
  card:          '#FFFFFF',
  primary:       '#2F5BFF',
  textPrimary:   '#0A0A0A',
  textSecondary: '#4A5468',
  border:        '#E5E7EB',
  accentEnergy:  '#6FCF97',
  accentGrowth:  '#9B8AFB',
  accentSystem:  '#56CCF2',
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  xxxl: 64,
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
};

export const shadow = {
  // Routes through theme variables so dark mode gets a heavier shadow.
  subtle: 'var(--shadow-sm), var(--shadow-md)',
};

export const fontStack =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const tokens = { colors, colorsLightHex, spacing, radius, shadow, fontStack };
export default tokens;
